import React from 'react'
import { Box, Divider } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Header, { HeaderVariant } from '../../../Elements/Header'
import SpaceBetweenSection from '../../../Elements/SpaceBetweenSection'
import CardFormHeader from '../../../Card/CardFormHeader'

const LCDHeader: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box>
      <SpaceBetweenSection
        isCentered
        marginRight={2}
        marginLeft={2}
        left={
          <CardFormHeader
            header={
              <Box>
                <Header
                  id="LCDLicensingTableHeader"
                  headerName={t(
                    'LCDLicensingTable.Header.Licensing',
                    'Licensing'
                  )}
                  component="h3"
                  variant={HeaderVariant.Card}
                />
              </Box>
            }
            headerContainerProps={{ marginLeft: 0 }}
          />
        }
        right={<></>}
      />
      <Divider sx={{ borderBottomWidth: '3px', padding: '25px, 0, 25px, 0' }} />
    </Box>
  )
}

export default LCDHeader
